var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.109375,
    width: 96,
    height: 96,
    rx: 48,
    transform: "rotate(0.0638669 0.109375 0)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_3177)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8248 60.1281L44.8524 35.4238C44.855 33.0784 43.9648 32.1393 41.7132 32.1368L36.0374 32.1305C33.7858 32.1279 32.8935 33.0651 32.8909 35.4104L32.8633 60.1147C32.8607 62.4601 33.7509 63.3992 36.0025 63.4017L41.6783 63.408C43.9299 63.4105 44.8222 62.4734 44.8248 60.1281Z",
    stroke: "black",
    strokeWidth: 5.36072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1373 60.149L64.1649 35.4448C64.1675 33.0994 63.2773 32.1603 61.0257 32.1578L55.3499 32.1515C53.1139 32.149 52.206 33.0861 52.2034 35.4314L52.1758 60.1357C52.1732 62.4811 53.0634 63.4202 55.315 63.4227L60.9908 63.429C63.2424 63.4315 64.1347 62.4944 64.1373 60.149Z",
    stroke: "black",
    strokeWidth: 5.36072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_127_3177_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-3.98374e-05 0.0357386 -0.0357386 -3.98374e-05 47.769 47.7784)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1062.5,
    y: -1062.5,
    width: 2125,
    height: 2125
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(0, 0, 0, 0.5013) 0deg,rgba(0, 0, 0, 0) 180.467deg,rgba(0, 0, 0, 1) 180.503deg,rgba(0, 0, 0, 0.5013) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5076 47.8182C83.4856 67.5561 67.4671 83.539 47.7292 83.517C27.9913 83.495 12.0085 67.4764 12.0305 47.7386C12.0525 28.0007 28.071 12.0178 47.8089 12.0398C67.5467 12.0618 83.5296 28.0804 83.5076 47.8182ZM19.1782 47.7465C19.1606 63.5368 31.9469 76.3517 47.7372 76.3693C63.5275 76.3869 76.3423 63.6006 76.3599 47.8103C76.3775 32.02 63.5912 19.2052 47.8009 19.1875C32.0106 19.1699 19.1958 31.9562 19.1782 47.7465Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":0.0},\"position\":0.50129848718643188},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":1.0},\"position\":0.50139850378036499}],\"stopsVar\":[{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":0.0},\"position\":0.50129848718643188},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":1.0},\"position\":0.50139850378036499}],\"transform\":{\"m00\":-0.079674772918224335,\"m01\":-71.477127075195312,\"m02\":83.547439575195312,\"m10\":71.477127075195312,\"m11\":-0.079674772918224335,\"m12\":12.079674720764160},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_127_3177_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.5076 47.8182C83.4856 67.5561 67.4671 83.539 47.7292 83.517C27.9913 83.495 12.0085 67.4764 12.0305 47.7386C12.0525 28.0007 28.071 12.0178 47.8089 12.0398C67.5467 12.0618 83.5296 28.0804 83.5076 47.8182ZM19.1782 47.7465C19.1606 63.5368 31.9469 76.3517 47.7372 76.3693C63.5275 76.3869 76.3423 63.6006 76.3599 47.8103C76.3775 32.02 63.5912 19.2052 47.8009 19.1875C32.0106 19.1699 19.1958 31.9562 19.1782 47.7465Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_3177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.4772,
    height: 71.4772,
    fill: "white",
    transform: "translate(12.0781 12) rotate(0.0638669)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.e4dc26fb25fd8ee3e954482ce8fadab0.svg";
export { ForwardRef as ReactComponent };